import { render, staticRenderFns } from "./AdministrativeForm.vue?vue&type=template&id=56d9c6d4&"
import script from "./AdministrativeForm.vue?vue&type=script&lang=js&"
export * from "./AdministrativeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports